var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormLayout',{attrs:{"title":"Cập nhật tài khoản kế toán"},scopedSlots:_vm._u([{key:"form",fn:function(){return [_c('InstallmentForm',{attrs:{"form-data":_vm.formData,"errors":_vm.errors}})]},proxy:true},{key:"actions",fn:function(){return [_c('FormActions',{attrs:{"loading":_vm.submitting,"cancel-route":{
        name: 'list-installment',
      }},on:{"save":function($event){return _vm.updateInstallment(_vm.formData)},"cancel":_vm.handleCancel}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }